import { Modal, Button } from 'antd';
import React, { Component } from 'react'
import TableC from '../../basicElement/TableC';
import API_URL from '../../../common/url';
import $ from '../../../common/AjaxRequest';

export default class CRCpeople extends Component {

    state = {
        visible: false,
        record: { },
        data: [],
        pagination: {
            current: 1,
            pageSize: 10,
        },
    }

    show = record => {
        this.setState({
            visible: true,
            record,
        },()=>{
            this.loadData();
        })
    }

    hide = () => {
        this.setState({
            visible: false,
            record: {},
            data: [],
        })
    }

    handleTableChange = (obj) => {
        this.setState({
            pagination: obj.pagination,
        },()=>{
            this.loadData();
        })
    }

    loadData = () => {
        const { pagination, record } = this.state;
        const { current, pageSize } = pagination;
        const { hospitalId, hospitalDepartmentId }= record;
        let url;
        if(hospitalDepartmentId){
            url = API_URL.hospital.queryHospitalDepartmentCrcInfo
        }else{
            url = API_URL.hospital.queryHospitalCrcInfo
        }
        const options = {
            method: 'POST',
            url,
            data: {
                hospitalId,
                hospitalDepartmentId,
                offset: current,
                limit: pageSize,
            },
            dataType: 'json',
            doneResult: data => {
                pagination.total = data.totalCount;
                this.setState({
                    data: data.datas,
                    pagination,
                });
            }
        }
        $.sendRequest(options);
    }

    getColumns = () => [{
        title: '序号',
        dataIndex: 'index',
        key: 'index',
        fixed: 'left',
        width: 60,
    }, {
        title: '工号',
        dataIndex: 'employeeCode',
        key: 'employeeCode',
        width: 100,
    }, {
        title: '姓名',
        dataIndex: 'userCompellation',
        key: 'userCompellation',
        width: 60,
    }, {
        title: '主管领导工号',
        dataIndex: 'leaderEmployeeCode',
        key: 'leaderEmployeeCode',
        width: 120,
    }, {
        title: '主管领导姓名',
        dataIndex: 'leaderUserCompellation',
        key: 'leaderUserCompellation',
        width: 120,
    }, {
        title: '职位',
        dataIndex: 'positionName',
        key: 'positionName',
        width: 150,
    }, {
        title: '入职时间',
        dataIndex: 'joinTime',
        key: 'joinTime',
        width: 120,
        render: (text) => {
            return text.substr(0,10);
        }
    }, {
        title: '临床试验经验年限（月）',
        dataIndex: 'workingLife',
        key: 'workingLife',
        width: 150,
    },
    ]

    render() {
        const { visible, record, data, pagination } = this.state;
        const { hospitalName, departmentLocalName, avgWorkLife } = record;
        return (
            <Modal
                title="现任CRC人数"
                visible={visible}
                onCancel={this.hide}
                className="preview-modal inv-detail"
                width="1000px"
                bodyStyle={{ maxHeight: 500 }}
                footer={<Button type="ghost" onClick={this.hide}>关闭</Button>}
            >
            <div className="primary-tabs-active" style={{ background:'#fff',padding:'10px 30px' }}>
                <div className="filter-bar">
                    <div className="filter-bar-investigation" style={{width:'100%'}}>
                        <span >医院名称：{hospitalName}&nbsp;&nbsp;|</span>
                        {departmentLocalName && <span >&nbsp;&nbsp;科室名称：{departmentLocalName}&nbsp;&nbsp;|</span>}
                        <span >&nbsp;&nbsp;临床试验操作经验平均值（月）：{avgWorkLife}</span>
                    </div>
                </div>

                <TableC
                    columns={this.getColumns()}
                    data={data}
                    onChange={this.handleTableChange}
                    scrollY={250}
                    pagination={pagination}
                />
            </div>
            </Modal>
        )
    }
    }



// WEBPACK FOOTER //
// ./src/components/hospital/hospitalInfo/CRCpeople.js